import { FunctionComponent, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { RevertIcon } from '@cbridge-tools/icons';
import { IFieldRevertButtonProps } from './FieldRevertButton.interface';

const StyledRevertButton = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(0.5),
  color: theme.palette.action.active,

  '&:hover': {
    color: theme.palette.text.primary,
  },
}));

export const FieldRevertButton: FunctionComponent<IFieldRevertButtonProps> = ({ onRevert }) => {
  const { t } = useTranslation();

  // Keep focus on the input; reverting shouldn't blur/validate the field.
  const handleMouseDown = (event: MouseEvent<HTMLButtonElement>) => event.preventDefault();

  return (
    <Tooltip title={t('text:common.filter.revertToDefault')}>
      <StyledRevertButton
        aria-label={t('text:common.filter.revertToDefault')}
        size={'small'}
        onMouseDown={handleMouseDown}
        onClick={onRevert}
      >
        <RevertIcon size={'small'} />
      </StyledRevertButton>
    </Tooltip>
  );
};
